import React, { useEffect, useState } from 'react';
import { IconButton } from 'office-ui-fabric-react';
import {useHistory, useRouteMatch} from 'react-router';
import { useSelector } from 'react-redux';

import { Props, Vehicle, ViewMode } from './Video.types';
import { Styled } from './Video.styles';
import { PageHeader } from '../components/PageHeader';
import { Tab } from './Tab';
import { tabs } from './consts';
import { VehicleInfo } from './VehicleInfo';
import { context } from './context';
import { CamerasList } from './CamerasList';
import { SingleCam } from './SingleCam';
import { securePostRequest, secureRequest } from '../../../../utils/request';
import { VehicleInfoPanel } from './VehicleInfoPanel';
import { useBoolean } from '../../../../hooks/useBoolean';
import { Page } from '../components/Page';
import {BackButton} from "../components/NavigationButton";

export const Video: React.FC<Props> = () => {
  const [selectedCam, setSelectedCam] = useState(1);
  const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.grid);
  const [vehicleInfo, setVehicleInfo] = useState<Vehicle | null>(null);
  const [requestId, setRequestId] = useState<string | null>(null);
  const [detailsOpen, toggleDetailsOpen] = useBoolean();

  const { params } = useRouteMatch<{ vehicle: string }>();

  useEffect(() => {
    const request = async () => {
      const vehicle = await secureRequest<Vehicle>(
        `/api/v1/map/online/${params.vehicle}`
      );
      setVehicleInfo(vehicle);
    };
    request();
  }, [params.vehicle]);

  useEffect(() => {
    const createRequest = async () => {
      const rq: { data: string } = await securePostRequest(
        '/api/v1/video/empty'
      )({
        vehicleId: Number(params.vehicle),
      });
      setRequestId(rq.data);
    };
    createRequest();
  }, [params.vehicle]);

  const onSelectCam = (cam: number) => {
    setViewMode(ViewMode.single);
    setSelectedCam(cam);
  };

  const history = useHistory()

  return (
    <context.Provider
      value={{
        vehicle: vehicleInfo,
        selectedCam,
        onSelectCam,
        requestId,
        toggleDetailsOpen,
      }}
    >
      <Page
        title="Потоковое видео"
        primaryButtonNode={<BackButton onClick={() => history.goBack()} />}
        actionButton={
          <IconButton
            onClick={toggleDetailsOpen}
            iconProps={{
              iconName: 'info',
            }}
          />
        }
      >
        {detailsOpen && <VehicleInfoPanel />}
        <VehicleInfo />
        <Styled.TabsWrapper>
          {tabs.map(({ view, icon }) => (
            <Tab
              key={icon}
              onSelect={() => setViewMode(view)}
              icon={icon}
              active={viewMode === view}
            />
          ))}
        </Styled.TabsWrapper>
        {viewMode === ViewMode.grid && <CamerasList />}
        {viewMode === ViewMode.single && <SingleCam />}
      </Page>
    </context.Provider>
  );
};
